module.exports = __webpack_public_path__ + "static/media/lucerne.0f026e6a.png";